<template>
    <modal
        :saveAction="save"
        :title="title"
        :id="id"
        :deleteAction="tag._id ? deleteAction : false"
        :actionButtons="true"
        size="lg"
        :closeButton="false"
        @shown="shown() "
    >
        <div class="row align-items-center mb-2">
            <div class="col-12">
                <b-form-group :label="$t('Label')">
                    <b-form-input v-model="tag.tag" :placeholder="$t('Ex.: VIP')"></b-form-input>
                </b-form-group>
            </div>
        </div>
        <div class="row align-items-center mb-2">
            <div class="col-12">
                <b-form-group :label="$t('Color')" class="mb-0"></b-form-group>

                <div
                    class="pointer col-1 mr-1 mb-1 p-2 text-center border rounded rounded-3 btn"
                    :class="'btn-' + color"
                    v-for="color in colors"
                    @click="tag.color=color"
                    :key="color"
                >
                    <i class="fe fe-check text-white p-0 m-0" v-if="color == tag.color"></i>
                    <span v-else>&nbsp;</span>
                </div>
            </div>
        </div>
    </modal>
</template>

<script>
import Modal from "@/components/Modal.vue";
import { mapActions, mapGetters, mapState } from 'vuex';
import { modalMixins } from '@/mixins/modal.js'


export default {
    name: 'TagFormModal',
    props: ['id', 'saveAction', 'data'],
    mixins: [modalMixins],
    components: {
        Modal,
    },
    data() {
        return {
            colors: ['success', 'light', 'info', 'danger', 'warning', 'white', 'primary', 'secondary', 'dark'],
            title: 'Tags',
            tag: {},
        }
    },
    computed: {

    },
    mounted() {

    },
    methods: {
        ...mapActions('tags', ['create', 'patch', 'remove']),

        save() {
            let promise, successMessage;
            if (this.tag._id) {
                promise = this.patch([this.tag._id, this.tag]);
                successMessage = this.$t('Item has been saved');
            } else {
                promise = this.create(this.tag);
                successMessage = this.$t('Item has been created');
            }


            promise.then(result => {
                this.$root.$emit('bv::hide::modal', this.id);
                this.$toasted.global.success({
                    message: successMessage
                });
            });
        },
        deleteAction() {

            this.remove(this.tag._id).then(result => {
                this.$toasted.global.success({
                    message: this.$t('Tag has been removed')
                });
            });
        },

        shown() {
            if (this.data._id)
                this.tag = this.data;
            else
                this.tag = {
                    color: null,
                };
            /* Switch back to the first tab */
        },
        validation(field) {
            if (this.errors && this.errors[field])
                return false
            else
                return null
        },


    },

}
</script>
<style>
.pre-formatted {
  white-space: pre;
}
</style>
